RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const SecondaryNavigationItem = views.SecondaryNavigationItem = Marionette.ItemView.extend({
        template: '#shellSecondaryNavigationItemTemplate',
        behaviors: {
            MenuItem: {
                behaviorClass: App.behaviors.MenuItem
            }
        },
        tagName: 'li',

        events: {
            click: 'onClick'
        },

        onClick: function () {
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ClickedSecondaryNavItem);
        }
    });

    // todo: make mixins a first class concept in Marionette/Backbone
    _.extend(SecondaryNavigationItem.prototype, App.mixins.Navigable);

});
